<template>
  <login-layout :title="layoutTit">
    <div class="login-suc-box">
      <i class=" icon iconfont icon-unselect suc-ico" />
      <p>{{ $t('message["1566"]') }}</p>
      <p>{{ duration }}{{ $t('message["641"]') }}…</p>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
export default {
  name: 'LoginSuc',
  components: {
    LoginLayout
  },
  data () {
    return {
      duration: 5
    }
  },
  computed: {
    layoutTit () {
      return this.$t('message["1381"]')
    }
  },
  created () {
    const interval = setInterval(() => {
      if (this.duration > 1) {
        this.duration--
      } else {
        this.$router.push('/')
        clearInterval(interval)
      }
    }, 1000)
  }
}
</script>
<style lang="scss" scoped>
  .login-suc-box {
    text-align: center;
    padding-top: 50px;
    padding-bottom: 120px;

    i {
      margin: 0 auto 16px;
      display: block;
    }

    p {
      line-height: 24px;
      font-weight: bold;
    }
  }
</style>
